import { getServiceSupporter } from '@/services/api-v1/api';
import { useState } from 'react';

export default () => {
  const [valueEnum, setValueEnum] = useState<Record<string, number> | null>(null);
  const [valueOptions, setValueOptions] = useState<{ value: number; label: string }[]>([]);
  const fetch = async () => {
    const res = await getServiceSupporter();
    setValueEnum(res.results.serviceSupporter);
    setValueOptions(
      Object.keys(res.results.serviceSupporter).map((key) => ({
        value: res.results.serviceSupporter[key],
        label: key,
      })),
    );
  };
  const reset = () => {
    setValueEnum(null);
    setValueOptions([]);
  };
  return {
    fetch,
    reset,
    valueEnum,
    valueOptions,
  };
};
